/**
 * K Practice Constants
 * K-specific overrides for practice screens
 *
 * Re-exports most values from PreK practice constants but overrides
 * timing constants specific to Kindergarten (e.g., shorter subitizing flash).
 */

// Import first (ESLint: import/first)
import { PRACTICE_TIMER_CONSTANTS as PREK_TIMER_CONSTANTS } from '../../PreKPractice/shared/practiceConstants';

// Re-export everything from PreK practice constants
export {
  PRACTICE_PHASES,
  PRACTICE_BADGE_CONFIG,
  PRACTICE_VISUAL_CONFIG,
  PRACTICE_CRITERIA,
  PRACTICE_TIMER_CONSTANTS,
  generatePracticeAnswerChoices,
  PREK_PRACTICE_TRACKS,
  // Note: We also export K_PRACTICE_TIMER_CONSTANTS below for K-specific overrides
} from '../../PreKPractice/shared/practiceConstants';

// ============================================================================
// K-Specific Timer Constants
// ============================================================================
export const K_PRACTICE_TIMER_CONSTANTS = {
  ...PREK_TIMER_CONSTANTS,
  // K subitizing flash duration (800ms - shorter than PreK's 1000ms)
  SUBITIZING_FLASH_MS: 800,
} as const;
